export enum REPORTS_DOWNLOAD_TYPE {
  CSV = 'csv',
  EXCEL = 'excel',
}
